import React from "react";
import { Box, Button } from "@mui/material";
import { authHeader } from "../../auth";

export default function ExportButtons({ category, finalRanking }) {
    const exportXML = async () => {
        // Récupère la config FIS (Raceheader/raceinfo/jury) saisie via la
        // page dédiée (/parallel-fis/:category) — vide si jamais
        // enregistrée, le XML sera alors généré avec un en-tête incomplet.
        let fisConfig = {};
        try {
            const cfgRes = await fetch(`/api/fis-config/${category}`, { headers: { ...authHeader() } });
            if (cfgRes.ok) fisConfig = await cfgRes.json();
        } catch {
            /* on continue avec fisConfig vide plutôt que de bloquer l'export */
        }

        const res = await fetch(`/api/finals/export-xml/${category}`, {
            method: "POST",
            headers: { "Content-Type": "application/json", ...authHeader() },
            body: JSON.stringify({ ranking: finalRanking, fisConfig }),
        });

        if (!res.ok) {
            console.error("XML export error:", await res.text());
            return;
        }

        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `final_${category}.xml`;
        a.click();
    };

    return (
        <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
            <Button variant="contained" color="secondary" onClick={exportXML}>
                Export FIS XML
            </Button>
        </Box>
    );
}